import {Injectable} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {StoreService} from './store/store.service';
import {UtilsService} from './utils/utils.service';
import {Observable} from 'rxjs';

@Injectable()
export class RoutingService {

  private readonly defaultLastPage: string = '/home';

  constructor(private route: ActivatedRoute,
              private utilService: UtilsService,
              private store: StoreService,
              private router: Router) {
    this.store.setLastPage({path: this.defaultLastPage, params: null});
  }

  setLastPage(path: string): void {
    this.store.setLastPage({path, params: null});
  }

  setLastPageParams(path: string): void {
    this.store.setLastPage({
      path,
      params: this.utilService.getCopyObject(this.route.queryParams)._value
    });
  }

  getParams(): Observable<Params> {
    return this.route.queryParams;
  }

  navigateToLastPage(): void {
    const lastPageStored = this.store.getLastPage();
    if (lastPageStored) {
      this.navigateTo(lastPageStored.path, lastPageStored.params);
    } else {
      this.navigateTo(this.defaultLastPage, null);
    }
  }

  deleteLastPage(): void {
    this.store.deleteLastPage();
  }

  navigateTo(pathPage: string, params?: any): void {
    if (params) {
      this.router.navigate([pathPage], {queryParams: params}).then();
    } else {
      this.router.navigate([pathPage]).then();
    }
  }

}
